var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-2 px-sm-0",domProps:{"innerHTML":_vm._s(_vm.localize(_vm.value.title))}})
}
var staticRenderFns = []

export { render, staticRenderFns }